import IField from "../../models/view/common/IField";

export const validateHasAnyValue = (value: string) => value !== undefined && value.length > 0;
export function validateEmail(email: string) {
  const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}
export function validatePassword(password: string){
  return password.length >= 8;
}

export function createValidationWithMessage(validation: (value: any) => boolean, errorMessage?: string){
  return (value: any): IValidationResult =>{
    const isValid = validation(value);
    return {isValid, errorMessage: isValid? undefined : errorMessage};
  }
}

export interface IValidationResult{
  isValid: boolean,
  errorMessage?: string,
}

export type ValidationFunction = (value: any) => IValidationResult;
/**
 * Validate the form field an emit changes so the UI, subscribers, etc can react.
 * @param formField
 * @param validations
 */
export function validate<TValue>(formField: IField<TValue>, validations: ValidationFunction[]){
  let hasErrors = false;
  formField.error.errorMessages = [];//clear out existing error messages
  for(const validation of validations){
    const {isValid, errorMessage} = validation(formField.value);
    if(!isValid){
      hasErrors = true;
      formField.error.isInErrorState = true;
      formField.error.errorMessages = formField.error.errorMessages || [];
      formField.error.errorMessages.push(errorMessage as string);
      formField.emitMessage({...formField});
    }
  }
  if(!hasErrors){
    formField.error.isInErrorState = false;
    formField.error.errorMessages = undefined;
    formField.emitMessage({...formField});
  }
  return !hasErrors;
}
